import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import Hls from "hls.js";
import { GlobalService } from "src/app/services/global.service";
import * as SecureLS from "secure-ls";
import { NgxSpinnerService } from "ngx-spinner";
import { StorageService } from "../../services/storage.service";
import { AppLogo1 } from "src/app/app.config";

@Component({
  selector: "app-liveclass",
  templateUrl: "./liveclass.component.html",
  styleUrls: ["./liveclass.component.css"],
})
export class LiveclassComponent implements OnInit {
  private ls = new SecureLS({ encodingType: "aes" });
  url: any;
  appLogo = AppLogo1;

  constructor(
    private storageService: StorageService,
    private route: ActivatedRoute,
    public globalService: GlobalService,
    private spinner: NgxSpinnerService
  ) {}

  async ngOnInit() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
      video_id: this.route.params["value"].video_id,
    };

    let video_details = await this.globalService.get(
      "classVideoDetail/get/class",
      filter
    );
    this.url = "/live/nfs-share" + video_details["content"].live_class_path;

    var video = <HTMLVideoElement>document.getElementById("my-video");
    if (Hls.isSupported()) {
      var hls = new Hls();

      hls.loadSource(this.url);
      hls.attachMedia(video);
      hls.on(Hls.Events.MANIFEST_PARSED, function () {
        video.play();
      });
    }
    this.updateVideoLog();
      setInterval(() => {
        this.updateVideoLog();
      }, 30000);
    this.spinner.hide();
  }

  async updateVideoLog() {
    // this.spinner.show();
    let inputDate = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
      video_details_id: this.route.params["value"].video_id,
      video_type: 1,
    };
    let video_log = await this.globalService.create(
      "videolog/student/video/log",
      inputDate
    );
    this.spinner.hide();
  }
}
